import Seo from "@/components/base/Seo";
import { SITE } from "@/config/site";
import { liveSessions } from "@/mocks/lives";
import { faqItems } from "@/mocks/content";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveNowStrip from "@/pages/home/components/LiveNowStrip";
import CategorySection from "@/pages/home/components/CategorySection";
import HotFeedSection from "@/pages/home/components/HotFeedSection";
import PlatformSection from "@/pages/home/components/PlatformSection";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import HomeFaqSection from "@/pages/home/components/HomeFaqSection";
import CtaSection from "@/pages/home/components/CtaSection";

const homeFaqs = faqItems.slice(0, 5);

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.name,
    alternateName: SITE.englishName,
    url: SITE.url,
    email: SITE.email,
    description: SITE.orgDesc,
    foundingDate: SITE.since,
    sameAs: [SITE.url],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.name,
    url: SITE.url,
    inLanguage: "zh-CN",
    description:
      "聚焦第一现场的直播资讯门户，提供现场实时画面、突发事态直击与直播镜头追踪。",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${SITE.url}/live?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "爆料直播官网｜现场实时画面与突发事态直击",
    url: `${SITE.url}/`,
    inLanguage: "zh-CN",
    description:
      "进入爆料直播，获取现场实时画面与突发事态直击，直播镜头追踪不停歇，实时画面信号稳定，还能听到现场连麦声音。",
    isPartOf: { "@type": "WebSite", url: SITE.url },
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "正在直播与回看的现场信号",
    itemListElement: liveSessions.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      url: `${SITE.url}/live/${item.id}`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="爆料直播官网｜现场实时画面与突发事态直击"
        description="爆料直播是聚焦第一现场的直播资讯门户，全天候提供现场实时画面、突发事态直击与直播镜头追踪，实时画面信号稳定不断流，还能听到现场连麦声音。突发事态、城市路况、民生现场分类齐全，吃瓜网友关心的第一现场，这里直接看。"
        keywords="爆料直播,现场实时画面,突发事态直击,直播镜头追踪,实时画面信号,现场连麦声音"
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <LiveNowStrip />
      <CategorySection />
      <HotFeedSection />
      <PlatformSection />
      <TestimonialSection />
      <HomeFaqSection />
      <CtaSection />
    </>
  );
}